export default "__VITE_ASSET__C6PY8NFq__"